import clsx from 'clsx';

export function Card({ className, children, ...props }) {
  return (
    <div className={clsx('glass-card glass-card-hover p-4 sm:p-6', className)} {...props}>
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-start justify-between mb-4">
      <div>
        <h3 className="text-base font-semibold text-foreground">{title}</h3>
        {subtitle && <p className="text-sm text-foreground-muted mt-0.5">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export default Card;
